var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ComposedMenuItemCollapsible',{attrs:{"link-tag":"button","to":"#","title":_vm.$t('theme'),"prefixIcon":{
        name: 'theme',
        path: 'activatable',
        activatable: true,
    }},on:{"input":function($event){_vm.$colorMode.preference = _vm.$colorMode.value === 'dark' ? 'light' : 'dark'}},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_c('ComposedSwitchThemeToggle',{nativeOn:{"click":function($event){$event.preventDefault();}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }